import React, { useState, useEffect } from "react";
import { Link, useParams  } from "react-router-dom";
import {
  FaCheck,
  FaPencilAlt,
  FaHeart,
  FaGlobe,
  FaLaptop,
  FaMapMarkerAlt,
  FaPlus,
  FaFilter,
} from "react-icons/fa";
import "../../components/UserProfile.css";
import LikeDislikeComponent from "../../components/LikeDislikeComponentUserProfile.js";
import Navbar from "../../components/Navbar.js";
import STAR_FULL from "../../assets/star-full.png";
import STAR_HALF from "../../assets/star-half.png";
import Modal from "react-modal";
import axios from "axios";
import ReviewComponent from "../../components/ReviewComponentuserProfile.js";

const convertBase64 = async (file) => {
  try {
    const filereader = new FileReader();
    filereader.readAsDataURL(file);

    return await new Promise((resolve, reject) => {
      filereader.onload = () => resolve(filereader.result);
      filereader.onerror = (error) => reject(error);
    });
  } catch (error) {
    throw error;
  }
};

const convertURL = async (base64) => {
  try {
    const response = await axios.post("https://uplbidet-api.vercel.app/upload-image", {
      image: base64,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const userData = await axios.post(
  "https://uplbidet-api.vercel.app/login-verification",
  {
    isAdmin: false,
  },
  { withCredentials: true }
);
console.log(userData)

const UserProfile = () => {
  
  const loggedInUserId = userData.data.id;

  // const loggedInUserId = useParams().data;
  const sampleId = useParams().data;

  const [user, setUser] = useState({});
  const [reviews, setReviews] = useState([]);
  const [profilePicture, setProfilePicture] = useState("");
  const [coverPhoto, setCoverPhoto] = useState("");
  const [isFollowing, setIsFollowing] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editedName, setEditedName] = useState(user.name);
  const [editedBio, setEditedBio] = useState(user.bio);
  const [editedCollege, setEditedCollege] = useState(user.college);
  const [editedCourse, setEditedCourse] = useState(user.course);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`https://uplbidet-api.vercel.app/api/users/${sampleId}`);
        if (!res.ok) {
          throw new Error("An error has occurred.");
        }

        const jsonData = await res.json();
        setUser(jsonData);
        console.log(jsonData);
        const isAlreadyFollowing = jsonData.followers.includes(loggedInUserId);
        setIsFollowing(isAlreadyFollowing);


      } catch (error) {
        console.error("Error fetching user data: ", error);
      }
    };

    fetchData();

  
  }, [isFollowing]);

  

  useEffect(() => {
      console.log("Fetching reviews...");
      const fetchReviews = async () => {
        try {
          const res = await fetch(`https://uplbidet-api.vercel.app/api/reviews/user/${sampleId}`);
          if (!res.ok) {
            throw new Error("An error has occured.");
          }
  
          const jsonReviews = await res.json();
       
          console.log(jsonReviews,"Add")
          setReviews(jsonReviews);
        } catch (error) {
          console.error("Error fetching reviews: ", error);
        }
      };
          fetchReviews();
      }, [loggedInUserId]
  );

  console.log(reviews)

 
  

  const handleFollow = async () => {
    try {
      const updatedUser = { ...user };
      const isAlreadyFollowing = updatedUser.followers.includes(loggedInUserId);

      if (isAlreadyFollowing) {
        updatedUser.followers = updatedUser.followers.filter(
          (followerId) => followerId !== loggedInUserId
        );
      } else {
        updatedUser.followers.push(loggedInUserId);
      }

      const res = await axios.post(
        `https://uplbidet-api.vercel.app/api/users/follow`,
        {current_user_id: loggedInUserId,user_to_follow_id:sampleId}
      );

      if (!res.ok) {
        throw new Error("An error has occurred.");
      }

      setUser(updatedUser);


      setIsFollowing(!isAlreadyFollowing);
    } catch (error) {
      console.error("Error updating user data: ", error);
    }
  };

  const openEditModal = () => {
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleFileChange = async (event, stateSetter) => {
    try {
      const file = event.target.files[0];
      if (file) {
        const base64 = await convertBase64(file);
        const url = await convertURL(base64);
        stateSetter(url);
      }
    } catch (error) {
      console.error(`Error converting ${stateSetter}:`, error);
    }
  };

  const handleProfilePictureChange = (event) => {
    handleFileChange(event, setProfilePicture);
  };

  const handleCoverPhotoChange = (event) => {
    handleFileChange(event, setCoverPhoto);
  };

  const handleEditProfile = async () => {
    try {
      const updatedUser = {
        ...user,
        username: editedName,
        bio: editedBio,
        college: editedCollege,
        degree_program: editedCourse,
        user_image: profilePicture || user.user_image,
        background_image: coverPhoto || user.background_image,
      };

      await updateData(updatedUser);
      setUser(updatedUser);
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const updateData = async (updatedUser) => {
    try {
      const res = await axios.put(
        `https://uplbidet-api.vercel.app/api/users/${sampleId}`,
        updatedUser
      );

      if (!res.ok) {
        throw new Error("An error has occurred.");
      }

      const jsonData = await res.json();
      setUser(jsonData);
      console.log(jsonData);
    } catch (error) {
      console.error("Error updating user data: ", error);
    }
  };

  const StaticRectangle = ({ position, size }) => {
    const style = {
      width: size.width,
      height: size.height,
    };

    return (
      <div
        className={`static-rectangle position-${position}`}
        style={style}
      ></div>
    );
  };

  return (
    <>
      <Navbar />
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="Edit Profile Modal"
      >
        <label htmlFor="profilePicture">Profile Picture:</label>
        <input
          type="file"
          id="profilePicture"
          accept="image/*"
          onChange={handleProfilePictureChange}
        />
        <label htmlFor="coverPhoto">Cover Photo:</label>
        <input
          type="file"
          id="coverPhoto"
          accept="image/*"
          onChange={handleCoverPhotoChange}
        />
        <label htmlFor="editedName">Name:</label>
        <input
          type="text"
          id="editedName"
          value={editedName}
          onChange={(e) => setEditedName(e.target.value)}
        />
        <label htmlFor="editedBio">Bio:</label>
        <input
          type="text"
          id="editedBio"
          value={editedBio}
          onChange={(e) => setEditedBio(e.target.value)}
        />
        <label htmlFor="editedCollege">College:</label>
        <input
          type="text"
          id="editedCollege"
          value={editedCollege}
          onChange={(e) => setEditedCollege(e.target.value)}
        />
        <label htmlFor="editedCourse">Course:</label>
        <input
          type="text"
          id="editedCourse"
          value={editedCourse}
          onChange={(e) => setEditedCourse(e.target.value)}
        />

        <button onClick={handleEditProfile}>Save</button>
        <button onClick={closeEditModal}>Cancel</button>
      </Modal>


      <div className="user-profile">
        <h2>{user.username}</h2>
        <img
          className="cover-photo"
          src={user.background_image || "../../assets/coverPhoto.jpg"}
          alt="User Profile"
        />
        <img
          className="profile-picture"
          src={user.user_image || "../../assets/profilePic.jpg"}
          alt="User Profile"
        />
        
        <div className="user-details">
          <pfollow>{`${user?.followers?.length || 0} Followers`}</pfollow>
          <p1>{user.college}</p1>
          <p2>{user.degree_program} </p2>
          <p3>{user.email}</p3>
          <p4>{user.bio} </p4>
          <h3 className="h3">Reviews</h3>
          <h4 className="h4">About</h4>
          <h5 className="h5">Bio</h5>

          <div className="location-icon">
            <FaMapMarkerAlt />
          </div>
          <div className="laptop-icon">
            <FaLaptop />
          </div>
          <div className="website-icon">
            <FaGlobe />
          </div>
          
         
        </div>
      </div>

      <div className="card-buttons-container">
        {loggedInUserId === sampleId ? (
          <Link
            to="#"
            className="button button-edit-profile"
            onClick={openEditModal}
          >
            <FaPencilAlt />
            <span>EDIT PROFILE</span>
          </Link>
        ) : (
          <button onClick={handleFollow} className="button button-follow">
            {isFollowing ? <FaCheck /> : <FaPlus />}
            <span>{isFollowing ? "FOLLOWING" : "FOLLOW"}</span>
          </button>
        )}

        <Link to="#" className="button button-filter">
          <FaFilter />
          <span>FILTER</span>
        </Link>
      </div>

      <StaticRectangle
        position="top-left"
        size={{ width: "860px", height: "80px" }}
      />
      <StaticRectangle
        position="top-right"
        size={{ width: "418px", height: "395px" }}
      />
      
      {/* Your additional JSX here */}
      {reviews.map((review) => (

<ReviewComponent
    logo={review.logo}
    userName={review.userName}
    timePublished={review.time_published}
    reviewRating={review.overall_rating}
    comment={review.comment}
    likes={review.likes}
/>
))}
    </>
  );
};

export default UserProfile;
